/* BASHES product page, rebuild theme. Oct 24 2026 */
(function () {
  function fmt(c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' USD'; }

  function addToCart(body, msgEl, cartUrl) {
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (msgEl) msgEl.textContent = 'Added to your cart.';
        var root = msgEl && msgEl.closest('.bp-pdp');
        if (root) {
          var view = root.querySelector('[data-view-cart]');
          if (view) view.hidden = false;
          root.querySelectorAll('[data-add]').forEach(function (b) {
            if (!b.dataset.label) b.dataset.label = b.innerHTML;
            b.innerHTML = 'Added <span class="bp-added-check" aria-hidden="true">&#10003;</span>';
            b.classList.add('is-added');
            clearTimeout(b._addedTimer);
            b._addedTimer = setTimeout(function () { b.innerHTML = b.dataset.label; b.classList.remove('is-added'); }, 30000);
          });
        }
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) { if (msgEl) msgEl.textContent = (err && err.description) || 'That did not go through. Please try again.'; });
  }

  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtns = root.querySelectorAll('[data-add]');
    var addedMsg = root.querySelector('[data-added]');
    var gallery = root.querySelector('[data-gallery]');
    var thumbs = root.querySelector('[data-thumbs]');
    var desktop = window.matchMedia('(min-width: 990px)');

    function tiles() { return Array.prototype.filter.call(gallery ? gallery.children : [], function (t) { return t.classList.contains('bp-photo'); }); }

    /* hybrid background: sample the active photo's edges */
    function blend() {
      if (root.dataset.tone !== 'auto' || !gallery) return;
      var tile = gallery.querySelector('.bp-photo.is-active') || tiles()[0];
      var img = tile && tile.querySelector('img');
      if (!img) return;
      var run = function () {
        try {
          var c = document.createElement('canvas'); c.width = 8; c.height = 8;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, 8, 8);
          var r = 0, g = 0, b = 0, n = 0;
          [[0,0],[7,0],[0,7],[7,7],[3,0],[0,3]].forEach(function (p) {
            var d = x.getImageData(p[0], p[1], 1, 1).data;
            if (d[3] > 200) { r += d[0]; g += d[1]; b += d[2]; n++; }
          });
          if (n) root.style.setProperty('--bp-photo-bg', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
        } catch (e) {}
      };
      if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
    }

    /* desktop viewer */
    function show(mediaId) {
      tiles().forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId)); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', b.dataset.target === String(mediaId) ? 'true' : 'false'); });
      blend();
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.target); });
    });

    /* mobile round previews on the first photo */
    var nav = null;
    function buildNav() {
      if (root.dataset.nav !== 'thumbs') return;
      var list = tiles();
      if (list.length < 2) return;
      nav = document.createElement('div');
      nav.className = 'bp-nav';
      nav.setAttribute('aria-label', 'Product photos');
      list.slice(0, 6).forEach(function (t, i) {
        var img = t.querySelector('img');
        var b = document.createElement('button');
        b.type = 'button'; b.dataset.target = t.dataset.mediaId;
        b.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + list.length);
        if (img) { var m = document.createElement('img'); m.src = img.currentSrc || img.src; m.alt = ''; b.appendChild(m); }
        b.addEventListener('click', function () {
          var target = gallery.querySelector('[data-media-id="' + b.dataset.target + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        nav.appendChild(b);
      });
      if (list.length > 6) { var s = document.createElement('span'); s.className = 'bp-nav__more'; s.textContent = '+' + (list.length - 6); nav.appendChild(s); }
      placeNav();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            nav.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', b.dataset.target === e.target.dataset.mediaId ? 'true' : 'false'); });
          });
        }, { threshold: 0.6 });
        list.forEach(function (t) { io.observe(t); });
      }
    }
    function placeNav() { if (nav && gallery.firstElementChild) gallery.firstElementChild.appendChild(nav); }
    buildNav();
    blend();

    /* variants */
    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('.bp-option'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      root.querySelectorAll('.bp-option').forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var t = opts.slice(); t[i] = inp.value;
          var v = findVariant(t);
          inp.nextElementSibling.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function setButtons(v) {
      addBtns.forEach(function (b) {
        b.disabled = !v || !v.available;
        b.textContent = !v ? 'Unavailable' : (v.available ? data.add : data.sold_out);
      });
    }
    function update() {
      var opts = selected();
      root.querySelectorAll('.bp-option').forEach(function (fs, i) {
        var l = fs.querySelector('[data-selected-label]'); if (l) l.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      markAvailability(opts);
      setButtons(v);
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-price-current]').forEach(function (p) { p.textContent = fmt(v.price); });
      var cmp = root.querySelector('[data-price-compare]');
      if (cmp) { if (v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = fmt(v.compare_at_price); } else { cmp.hidden = true; } }
      var vl = root.querySelector('[data-sticky-variant]'); if (vl) vl.textContent = v.title === 'Default Title' ? '' : v.title;
      if (v.featured_media && gallery) {
        var tile = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (tile) {
          if (desktop.matches && root.dataset.desktopGallery === 'viewer') { show(v.featured_media.id); }
          else if (tile !== gallery.firstElementChild) { gallery.insertBefore(tile, gallery.firstElementChild); placeNav(); blend(); }
        }
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('.bp-option input').forEach(function (inp) { inp.addEventListener('change', update); });
    if (root.querySelector('.bp-option')) markAvailability(selected());

    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = root.querySelector('.bp-qty input');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    function submit(e) {
      if (e) e.preventDefault();
      if (addBtns[0].disabled) return;
      if (root._validate && !root._validate()) return;
      addBtns.forEach(function (b) { b.disabled = true; });
      addToCart(new FormData(form), addedMsg, data.cart_url).finally(function () { addBtns.forEach(function (b) { b.disabled = false; }); });
    }
    form.addEventListener('submit', submit);
    var stickyBtn = root.querySelector('.bp-sticky [data-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { submit(); });

    /* sticky bar appears once the main button scrolls away (phone only) */
    var sticky = root.querySelector('.bp-sticky');
    var mainBtn = root.querySelector('.bp-buy [data-add]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(mainBtn);
    }

    /* pair with: quick add */
    root.querySelectorAll('[data-pair-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var fd = new FormData(); fd.append('id', b.dataset.pairAdd); fd.append('quantity', '1');
        b.disabled = true;
        addToCart(fd, addedMsg, data.cart_url).finally(function () { b.disabled = false; });
      });
    });

    root.dispatchEvent(new CustomEvent('bp:ready', { bubbles: true }));
  }

  function boot() { document.querySelectorAll('.bp-pdp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  /* you may also like: load Shopify recommendations into the carousel */
  function bootRecs() {
    document.querySelectorAll('[data-bp-recs]').forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-bp-recs]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.hidden = false; wire(el); }
      });
    });
  }
  function wire(el) {
    var track = el.querySelector('.bp-recs__track');
    el.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8 * parseInt(b.dataset.dir, 10), behavior: 'smooth' }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootRecs); else bootRecs();
})();

/* recently viewed: remembers the last 12 pieces in this browser only */
(function () {
  var KEY = 'bashes_recently_viewed';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  var current = m ? decodeURIComponent(m[1]) : null;
  if (current) { var l = read().filter(function (h) { return h !== current; }); l.unshift(current); write(l.slice(0, 12)); }
  function fmt(c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' USD'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function render(el) {
    if (el.dataset.bound) return; el.dataset.bound = '1';
    var max = parseInt(el.dataset.limit || '6', 10);
    var handles = read().filter(function (h) { return h !== current; }).slice(0, max);
    if (!handles.length) return;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;
      var row = el.querySelector('.bp-rv__row');
      row.innerHTML = items.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        return '<a class="bp-rv__item" href="' + p.url + '">' +
          '<span class="bp-rv__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="bp-rv__txt"><span class="bp-rv__title">' + esc(p.title) + '</span><span class="bp-rv__price">' + (p.price_varies ? 'From ' : '') + fmt(p.price_min) + '</span></span></a>';
      }).join('');
      el.hidden = false;
    });
  }
  function boot() { document.querySelectorAll('[data-bp-rv]').forEach(render); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
